export function cloneDeep<T = unknown>(v: T): T {
  if (v instanceof Object) {
    return JSON.parse(JSON.stringify(v));
  }

  return v;
}
